import { useSyncExternalStore } from 'react'
import { queryClient } from '../../lib/queryClient'
import { persistible } from '../../lib/persist'

// De cuándo son los datos que se están viendo AHORA. Alimenta el aviso de
// frescura del NetChip.
//
// Se agrega globalmente en vez de exigir que cada pantalla declare "su" consulta
// principal, porque ese concepto no existe en camp: el dashboard dispara 3-4
// consultas, un proyecto suma las de su pestaña activa, y el chat ni siquiera pasa
// por react-query (va por listener de Firestore). Filtrar por OBSERVADORES VIVOS da
// el comportamiento "por pantalla" gratis: solo cuenta lo que hay montado.
//
// Se toma el MÁS VIEJO: si una pantalla mezcla datos de distinta edad, lo honesto
// es reportar el peor caso, no el mejor.
function snapshot(): number {
  let masViejo = 0
  for (const q of queryClient.getQueryCache().getAll()) {
    if (q.getObserversCount() === 0) continue
    if (q.state.status !== 'success') continue
    if (!q.state.dataUpdatedAt) continue
    // MISMA allowlist que el disco: solo tiene sentido reportar la edad de lo que
    // de verdad sobrevive sin red.
    if (!persistible(q.queryKey as readonly unknown[])) continue
    masViejo = masViejo === 0 ? q.state.dataUpdatedAt : Math.min(masViejo, q.state.dataUpdatedAt)
  }
  return masViejo // 0 = no hay nada que reportar
}

// El cache de react-query AVISA DURANTE EL RENDER de otro componente: al montarse un
// useQuery con una clave que nunca se había visto, QueryObserver construye la entrada
// dentro del cuerpo del render y el cache emite 'added' ahí mismo. Si contestamos en
// ese instante, el setState interno de useSyncExternalStore cae dentro del render
// ajeno y React lo canta en rojo ("Cannot update a component (NetChip) while rendering
// a different component"). Pasaba al abrir una nota: RichEditor llama a
// useSugerenciaTarea, que monta su consulta de estado de IA en pleno render.
//
// Se contesta un microtask después: para entonces el render ya terminó y el aviso
// sigue siendo instantáneo a ojos de quien mira (la frescura se cuenta en minutos, no
// en frames). De paso colapsa las ráfagas — una pantalla monta tres o cuatro consultas
// de golpe — en un solo aviso.
//
// La función vive FUERA del hook para que su identidad sea estable: si se creara en
// cada render, useSyncExternalStore se desuscribiría y volvería a suscribirse cada vez.
export function suscribir(cb: () => void): () => void {
  let programado = false
  let vivo = true
  const desuscribir = queryClient.getQueryCache().subscribe(() => {
    if (programado || !vivo) return
    programado = true
    queueMicrotask(() => {
      programado = false
      if (vivo) cb()
    })
  })
  return () => {
    vivo = false
    desuscribir()
  }
}

// Devuelve un NÚMERO, no un objeto: useSyncExternalStore compara por identidad y
// un objeto nuevo en cada llamada provocaría un bucle de renders.
export function useFrescura(): number {
  return useSyncExternalStore(suscribir, snapshot, () => 0)
}
